export default function AuthorityAndManagementDirective() {
  return {
    template: require('./authority-and-management.html'),
    scope: {
      assessmentId: '@',
      customerId: '@',
      status: '@',
      includeKeyContacts: '@',
    },
    controller: 'AuthorityAndManagementController',
    controllerAs: 'authorityAndManagementVM',
    bindToController: true,
    replace: true,
  };
}
